module.exports = __webpack_public_path__ + "img/DigitalCalendar1.ce19f87b.jpg";